<template>
  <div class="viq-feedback">
    <button
      class="viq-feedback__btn"
      :class="{ 'viq-feedback__btn--active-up': rating === 'up', 'viq-feedback__btn--disabled': !!rating && rating !== 'up' }"
      :disabled="!!rating"
      title="Helpful"
      @click="handleUp"
    >
      <svg width="14" height="14" viewBox="0 0 20 20" fill="currentColor">
        <path d="M2 10.5a1.5 1.5 0 113 0v6a1.5 1.5 0 01-3 0v-6zM6 10.333v5.43a2 2 0 001.106 1.79l.05.025A4 4 0 008.943 18h5.416a2 2 0 001.962-1.608l1.2-6A2 2 0 0015.56 8H12V4a2 2 0 00-2-2 1 1 0 00-1 1v.667a4 4 0 01-.8 2.4L6.8 7.933a4 4 0 00-.8 2.4z" />
      </svg>
    </button>
    <button
      class="viq-feedback__btn"
      :class="{ 'viq-feedback__btn--active-down': rating === 'down', 'viq-feedback__btn--disabled': !!rating && rating !== 'down' }"
      :disabled="!!rating"
      title="Not helpful"
      @click="handleDown"
    >
      <svg width="14" height="14" viewBox="0 0 20 20" fill="currentColor" style="transform: rotate(180deg);">
        <path d="M2 10.5a1.5 1.5 0 113 0v6a1.5 1.5 0 01-3 0v-6zM6 10.333v5.43a2 2 0 001.106 1.79l.05.025A4 4 0 008.943 18h5.416a2 2 0 001.962-1.608l1.2-6A2 2 0 0015.56 8H12V4a2 2 0 00-2-2 1 1 0 00-1 1v.667a4 4 0 01-.8 2.4L6.8 7.933a4 4 0 00-.8 2.4z" />
      </svg>
    </button>

    <span v-if="rating === 'up'" class="viq-feedback__thanks">Thanks!</span>
    <span v-if="reason" class="viq-feedback__reason-label">
      {{ reasonLabel }}
    </span>

    <div v-if="showReasons" class="viq-feedback__reasons">
      <button
        v-for="r in reasons"
        :key="r.value"
        class="viq-feedback__pill"
        @click="handleReason(r.value)"
      >{{ r.label }}</button>
    </div>
  </div>
</template>

<script>
const DOWNVOTE_REASONS = [
  { value: "inaccurate", label: "Inaccurate" },
  { value: "not_relevant", label: "Not relevant" },
  { value: "missing_information", label: "Missing information" },
  { value: "too_vague", label: "Too vague" },
];

export default {
  name: "ViqFeedback",
  props: {
    messageId: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      rating: null,
      showReasons: false,
      reason: null,
      reasons: DOWNVOTE_REASONS,
    };
  },
  computed: {
    reasonLabel() {
      if (!this.reason) return "";
      const found = DOWNVOTE_REASONS.find((r) => r.value === this.reason);
      return found ? found.label : "";
    },
  },
  methods: {
    handleUp() {
      if (this.rating) return;
      this.rating = "up";
      this.showReasons = false;
      this.send("up");
    },
    handleDown() {
      if (this.rating) return;
      this.rating = "down";
      this.showReasons = true;
    },
    handleReason(val) {
      this.reason = val;
      this.showReasons = false;
      this.send("down", val);
    },
    send(rating, reason) {
      if (!this.messageId) return;
      this.$store.dispatch("Viq/submitFeedback", {
        query_log_id: this.messageId,
        rating,
        reason: reason || null,
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/viq.scss";

.viq-feedback {
  display: flex;
  align-items: center;
  gap: 2px;
  margin-top: $viq-space-xs;

  &__btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 26px;
    height: 26px;
    padding: 0;
    border: none;
    background: none;
    color: $viq-text-muted;
    border-radius: $viq-radius-sm;
    cursor: pointer;
    transition: color $viq-transition-fast;

    &:hover:not(:disabled) {
      color: $viq-text-secondary;
    }

    &--active-up {
      color: #22c55e !important;
      cursor: default;
    }

    &--active-down {
      color: #ef4444 !important;
      cursor: default;
    }

    &--disabled {
      color: $viq-border !important;
      cursor: default;
    }
  }

  &__thanks {
    font-size: $viq-font-xs;
    color: $viq-text-muted;
    margin-left: $viq-space-xs;
  }

  &__reason-label {
    font-size: $viq-font-xs;
    color: $viq-text-muted;
    margin-left: $viq-space-xs;
  }

  &__reasons {
    display: flex;
    align-items: center;
    gap: 4px;
    margin-left: $viq-space-xs;
  }

  &__pill {
    font-size: $viq-font-xs;
    color: $viq-text-secondary;
    background: $viq-bg-secondary;
    border: 1px solid $viq-border;
    border-radius: $viq-radius-full;
    padding: 2px 10px;
    cursor: pointer;
    white-space: nowrap;
    transition: background $viq-transition-fast, border-color $viq-transition-fast;

    &:hover {
      background: darken(#f9fafb, 3%);
      border-color: darken($viq-border, 8%);
    }
  }
}
</style>
